export const ASSETS_TABLE_WIDGET = 'ASSETS_TABLE_WIDGET';
export const LINK_WIDGET = 'LINK_WIDGET';
export const BUTTON_WIDGET = 'BUTTON_WIDGET';